const CURRENT_HOTEL_GRAPH_COLOR = '#2081AC';
export default CURRENT_HOTEL_GRAPH_COLOR;
